import React from "react";
import PropTypes from "prop-types";
import { Button } from "react-bootstrap";
import ModalApp from "../../../../components/ModalApp";

const HotelTermsModal = ({ show, handleModal }) => {
  return (
    <ModalApp show={show} handleModal={handleModal}>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          maxHeight: "70vh",
        }}
      >
        <h5
          className="text-center font-wl-600"
          style={{
            padding: "0 16px 16px 16px",
            margin: 0,
            borderBottom: "1px solid #eee",
            flexShrink: 0,
          }}
        >
          TERMOS E CONDIÇÕES DE USO HOTÉIS
        </h5>
        <div
          style={{
            flex: 1,
            overflowY: "auto",
            padding: "16px",
            textAlign: "left",
          }}
        >
          <h5
            className="text-center font-wl-600"
            style={{
              padding: "0 16px 8px 16px",
              margin: 0,
              borderBottom: "1px solid #eee",
              flexShrink: 0,
            }}
          >
            1. HOSPEDAGEM
          </h5>
          <p className="text-sm mb-3">
            <strong>1.</strong> Após o resgate, o envio das informações
            relativas ao serviço e a emissão da reserva (voucher) se dará
            por meio do e-mail informado pelo participante em seu cadastro
            no programa, sendo de sua exclusiva responsabilidade a
            veracidade das informações fornecidas. O programa não se
            responsabiliza pelo não recebimento do e-mail pelo participante.
          </p>
          <p className="text-sm mb-3">
            <strong>1.1</strong> Caso o participante não venha a receber o
            e-mail com a informação de seu resgate/voucher no prazo de até
            24 (vinte e quatro) horas contadas do resgate, deverá entrar em
            contato com a Central de Atendimento do Programa. ainda, um
            sofá-cama.
          </p>
          <p className="text-sm mb-3">
            <strong>1.2</strong> O Cliente deverá preencher todos os campos
            com dados exatos para poder realizar reservas válidas e se
            responsabiliza pela veracidade, exatidão, vigência e
            autenticidade dos dados inseridos. Os dados deverão coincidir de
            forma exata com a documentação de viagem necessária para o
            check-in. O Programa não se responsabiliza por eventuais erros
            de digitação do Cliente.
          </p>
          <p className="text-sm mb-3">
            <strong>1.3</strong> O nome do hotel e o tipo de acomodação
            adquirida constam da respectiva ordem de serviço (voucher), a
            qual deverá ser apresentada no estabelecimento comercial no
            momento do check in.
          </p>
          <p className="text-sm mb-3">
            <strong>1.4</strong> O hotel poderá oferecer diferentes
            acomodações: o apartamento duplo poderá ter 02 (duas) camas
            separadas ou 01 (uma) de casal; os apartamentos triplos ou
            quádruplos poderão ter (i) 02 (duas) camas de casal ou (ii) 02
            (duas) camas de solteiro e 02 (duas) camas articuladas, ou,
            ainda, um sofá-cama.
          </p>
          <p className="text-sm mb-3">
            <strong>1.5</strong> A entrada (check-in) geralmente é
            autorizada a partir das 15 (quinze) horas. A entrada em horário
            anterior às 15 (quinze) horas estará condicionada à
            disponibilidade e aprovação do hotel, cabendo ao Cliente
            consultar o estabelecimento, não podendo o Programa ser
            responsabilizado em caso de impossibilidade de acomodação em
            horário anterior ao mencionado neste item.
          </p>
          <p className="text-sm mb-3">
            <strong>1.6</strong> A saída (check-out) normalmente é realizada
            às 10 (dez) horas, cabendo ao Cliente verificar com o
            estabelecimento a possibilidade de extensão da estadia.
          </p>
          <p className="text-sm mb-3">
            <strong>1.7</strong> Os horários de check-in e check-out podem
            variar dependendo do regulamento de cada hotel, cabendo ao
            Cliente pagar diretamente ao estabelecimento eventuais valores
            referentes à utilização de diárias extras.
          </p>
          <p className="text-sm mb-3">
            <strong>1.8</strong> Os hotéis poderão, a seu critério e sob sua
            responsabilidade, solicitar o cartão de crédito do Cliente para
            caucionar eventuais despesas. Caberá ao Cliente verificar junto
            ao hotel acerca de eventual valor a ser caucionado durante sua
            estadia, bem como a disponibilidade de limite no seu cartão de
            crédito.
          </p>
          <p className="text-sm mb-3">
            <strong>1.9</strong> Na hipótese do Cliente não realizar o
            check-in até às 18 (dezoito) horas, horário local do hotel, este
            poderá cancelar integralmente a reserva pré-existente. O
            apartamento reservado será devolvido ao inventário do hotel
            automaticamente, podendo ser revendido a critério do hotel ou
            fornecedor sem crédito para o Cliente. Havendo necessidade, o
            cliente pode informar-se sobre a chegada ao hotel após às 18hrs,
            diretamente com o estabelecimento.
          </p>
          <p className="text-sm mb-3">
            <strong>1.10</strong> Devido à política de alguns setores de
            reservas de hotéis, os nomes indicados na reserva somente são
            enviados para o estabelecimento hoteleiro na semana de seu
            check-in. Por isso, é possível que o quarto esteja reservado,
            porém o nome ainda não esteja inserido no inventário do hotel.
          </p>
          <p className="text-sm mb-3">
            <strong>1.11</strong> Se o Cliente quiser reservar mais de um
            quarto, deverá utilizar nomes diferentes para cada quarto, pois
            reservas duplicadas, ou seja, com o mesmo nome, poderão ser
            canceladas pelo hotel.
          </p>
          <p className="text-sm mb-3">
            <strong>1.12</strong> Em hotéis, o café da manhã e/ou as
            refeições, quando inclusas nas diárias, são contratados com os
            hotéis e/ou restaurante locais, sendo o menu fixo, com bebidas
            não inclusas e horários pré estabelecidos. Se incluso, o regime
            de alimentação estará indicado no voucher. Crianças não pagantes
            que compartilham o apartamento com adultos, utilizando o plano
            familiar do hotel, não têm direito a café-da-manhã e/ou
            refeições na forma de cortesia.
          </p>
          <p className="text-sm mb-3">
            <strong>1.13</strong> As informações específicas da hospedagem,
            como nome, localização, categoria, fotos e serviços incluídos
            são fornecidas pelos próprios estabelecimentos de hospedagem,
            sendo de inteira responsabilidade destes. O Programa não poderá
            ser responsabilizado por eventuais discrepâncias havidas entre
            os dados informados pelo estabelecimento, imagens e a situação
            real e localização dos hotéis.
          </p>
          <p className="text-sm mb-3">
            <strong>1.14</strong> É recomendado que, em caso de dúvidas, o
            Cliente tome conhecimento dos comentários e avaliações de outros
            hóspedes para verificar se a hospedagem se ajusta às suas
            preferências e necessidades. O Programa não é e não deve ser
            interpretado como um promotor da qualidade, do nível de serviço
            e/ou da qualificação ou classificação de qualquer hospedagem.
          </p>
          <p className="text-sm mb-3">
            <strong>1.15</strong> No momento da saída do hotel, o Cliente
            deverá verificar com atenção a fatura apresentada. O voucher do
            Programa deverá ter sido aplicado para pagamento dos serviços
            nele discriminados. E, no cartão de crédito do Cliente, deverá
            ser debitado somente o valor de despesas extras e adicionais.
          </p>
          <p className="text-sm mb-3">
            <strong>1.16</strong> É de inteira responsabilidade do Cliente
            verificar a ocorrência de débitos indevidos em seu cartão de
            crédito ou qualquer outra situação adversa, cuja resolução
            deverá ser resolvida diretamente com a hospedagem e/ou com a
            administradora do cartão de crédito.
          </p>
          <h5
            className="text-center font-wl-600"
            style={{
              padding: "0 16px 8px 16px",
              margin: 0,
              borderBottom: "1px solid #eee",
              flexShrink: 0,
            }}
          >
            2. ALTERAÇÕES DE RESERVAS
          </h5>
          <p className="text-sm mb-3">
            <strong>2.1</strong> As reservas de hotéis realizadas por meio
            do programa estão sujeitas às políticas de alteração
            estabelecidas pelo hotel, rede hoteleira ou fornecedor
            contratado, podendo variar de acordo com o tipo de tarifa,
            período da estadia, destino e condições promocionais.
          </p>
          <p className="text-sm mb-3">
            <strong>2.2</strong> As solicitações de alteração (datas, nome
            do hóspede, tipo de acomodação ou outras condições) estão
            sujeitas à disponibilidade e aprovação do hotel no momento da
            solicitação.
          </p>
          <p className="text-sm mb-3">
            <strong>2.3</strong> Alterações podem implicar reajuste de
            valores, cobrança de diferenças tarifárias e/ou aplicação de
            taxas adicionais, conforme política vigente do hotel.
          </p>
          <h5
            className="text-center font-wl-600"
            style={{
              padding: "0 16px 8px 16px",
              margin: 0,
              borderBottom: "1px solid #eee",
              flexShrink: 0,
            }}
          >
            3. CANCELAMENTO DE RESERVAS
          </h5>
          <p className="text-sm mb-3">
            <strong>3.1</strong> As reservas de hotéis realizadas por meio
            do programa estão sujeitas às políticas de cancelamento
            estabelecidas pelo hotel, rede hoteleira ou fornecedor
            contratado, podendo variar de acordo com o tipo de tarifa,
            período da estadia, destino e condições promocionais.
          </p>
          <p className="text-sm mb-3">
            <strong>3.2</strong> O cancelamento das reservas deverá
            respeitar o prazo e as condições definidos pelo hotel,
            informados no momento da confirmação da reserva.
          </p>
          <p className="text-sm mb-3">
            <strong>3.3</strong> Cancelamentos realizados dentro do prazo
            permitido poderão estar sujeitos à cobrança de taxas
            administrativas ou multas, conforme política do fornecedor.
          </p>
          <p className="text-sm mb-3">
            <strong>3.4</strong> Cancelamentos efetuados fora do prazo, bem
            como no-show (não comparecimento), poderão resultar na cobrança
            integral da estadia, sem direito a reembolso.
          </p>
          <p className="text-sm mb-3">
            <strong>3.5</strong> Em tarifas não reembolsáveis, não será
            permitido cancelamento ou reembolso, independentemente do
            motivo.
          </p>
          <h5
            className="text-center font-wl-600"
            style={{
              padding: "0 16px 8px 16px",
              margin: 0,
              borderBottom: "1px solid #eee",
              flexShrink: 0,
            }}
          >
            4. PRAZOS
          </h5>
          <p className="text-sm mb-3">
            <strong>4.1</strong> Somente serão aceitas solicitações de
            cancelamento ou alteração de pedidos já emitidos caso o cliente
            o faça com no mínimo 72 horas de antecedência do embarque.
          </p>
          <p className="text-sm mb-3">
            <strong>4.2</strong> Recomenda-se que o participante do programa
            verifique atentamente as condições específicas antes da
            confirmação da reserva.
          </p>
          <h5
            className="text-center font-wl-600"
            style={{
              padding: "0 16px 8px 16px",
              margin: 0,
              borderBottom: "1px solid #eee",
              flexShrink: 0,
            }}
          >
            5. REEMBOLSO DE PONTOS
          </h5>
          <p className="text-sm mb-3">
            <strong>5.1</strong> Quando aplicável, o reembolso de pontos
            será realizado exclusivamente na conta do participante titular
            da reserva, respeitando as regras do Programa e as políticas do
            fornecedor.
          </p>
          <p className="text-sm mb-3">
            <strong>5.2</strong> O prazo para reembolso de pontos, quando
            autorizado, seguirá conforme a política geral do Programa a
            partir da confirmação do cancelamento pelo fornecedor.
          </p>
          <p className="text-sm mb-3">
            <strong>5.3</strong> Pontos reembolsados não terão validade
            estendida, permanecendo sujeitos às regras originais de
            expiração do Programa.
          </p>
          <h5
            className="text-center font-wl-600"
            style={{
              padding: "0 16px 8px 16px",
              margin: 0,
              borderBottom: "1px solid #eee",
              flexShrink: 0,
            }}
          >
            6. RESPONSABILIDADE
          </h5>
          <p className="text-sm mb-3">
            <strong>6.1</strong> O Programa não se responsabiliza por:
          </p>
          <p className="text-sm mb-3">
            <strong>.</strong> Alterações unilaterais das políticas dos
            hotéis;
          </p>
          <p className="text-sm mb-3">
            <strong>.</strong> Indisponibilidade de acomodações;
          </p>
          <p className="text-sm mb-3">
            <strong>.</strong> Serviços não prestados pelo hotel;
          </p>
          <p className="text-sm mb-3">
            <strong>.</strong> Multas, taxas ou penalidades aplicadas pelo
            fornecedor.
          </p>
          <h5
            className="text-center font-wl-600"
            style={{
              padding: "0 16px 8px 16px",
              margin: 0,
              borderBottom: "1px solid #eee",
              flexShrink: 0,
            }}
          >
            7. DISPOSIÇÕES GERAIS
          </h5>
          <p className="text-sm mb-3">
            <strong>7.1</strong> O programa atua como intermediador da
            reserva, não sendo responsável por políticas definidas pelos
            hotéis ou fornecedores.
          </p>
          <p className="text-sm mb-3">
            <strong>7.2</strong> O resgate de pontos para reservas de hotéis
            implica a aceitação integral e irrestrita dos termos deste
            regulamento, bem como das políticas específicas do hotel ou
            fornecedor parceiro.
          </p>
        </div>
        <div
          className="text-center"
          style={{
            padding: "16px",
            borderTop: "1px solid #eee",
            flexShrink: 0,
          }}
        >
          <Button
            type="button"
            className="btn-default-wl text-xxs font-wl-700"
            onClick={handleModal}
            style={{ minWidth: "150px" }}
          >
            FECHAR
          </Button>
        </div>
      </div>
    </ModalApp>
  );
};

HotelTermsModal.propTypes = {
  show: PropTypes.bool.isRequired,
  handleModal: PropTypes.func.isRequired,
};

export default HotelTermsModal;
